import React from "react";
import RGL, { WidthProvider } from "react-grid-layout";
import Paper from '@material-ui/core/Paper';
import {Card, withStyles} from '@material-ui/core';
import WelcomeCard from "../WelComeCard/index";
import WelComeBanner from "../WelcomeBanner";
import AttGöraTabell from "../Tables/AttgöraTabell";
import AttGöraNy from "../AttGöraNy";
import Flöde from "../Wall/index";
import ExtraLargeProgress from "../../DashboardComponents/DashboardIndividuell/Inputs/ExtraLarge/ExtraLargeProgress";
import Aktiviteter from "../../DashboardComponents/DashboardIndividuell/Inputs/Large/Aktiviteter";
import Donut from '../DataComponents/donut'
import List from '../DataComponents/list'
import {getVunnenMonthChartByUserid, getAktiviterByUserid, getMoteLobbyByUserid, getDashboardCompetitionList
} from 'actions'
import {connect} from 'react-redux' 
import {isEmpty, isNull, isUndefined} from 'lodash'
import DashboardTävlingar from "../DashboardTävlingar";
import DashboardBG from '../../DashboardComponentsV2/Images/notyfile_dashboard_bg.svg'
import {NumberFormat} from 'components/NotyNumberFormat'
import moment from 'moment'
import IntlMessages from 'util/IntlMessages';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

const ReactGridLayout = WidthProvider(RGL);

const styles = theme => ({
  tavlingBg: {
    backgroundImage: `url(${DashboardBG})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  }
});

// Lägg till/Ta bort "static: true" på paper för göra boxarna flyttbara eller statiska

class StaticElementsLayout extends React.PureComponent {

  constructor(props ){
    super( props );
    this.handleGetVunnenMonthChartByUserid = this.handleGetVunnenMonthChartByUserid.bind(this)
    this.handleGetAktiviterByUserid = this.handleGetAktiviterByUserid.bind(this)
    this.handleGetMoteByUserid = this.handleGetMoteByUserid.bind(this)
    this.createAktivitetData = this.createAktivitetData.bind(this)
  }
  getDashBoardValueOf = ()=>{
    try{
    let ModuleValue = JSON.parse(this.props.DashBoardValueOf).find(item=>parseInt(item.DashBaord) === 1)
    if(ModuleValue.Value > 2 && ModuleValue.Value !== 5){
        return 2
    }else{
        return 1
    }
}
catch(error){return 1}
}
  formatNumber=(number)=>{
    const _ValueOF = this.getDashBoardValueOf()
    return NumberFormat(number, _ValueOF === 2?'total':'compact', _ValueOF === 2?'default':'currency', 0)
    return NumberFormat(number, 'compact', 'auto', 0)
      if(number > 1000000){
          return `${(number/1000).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$& ')}K`
      }else if(number > 1000){
          return `${(number/1000).toFixed(0)}K`
      }else{
          return parseInt(number)
      }
  }
  formatNumber2=(number)=>{
    const _ValueOF = this.getDashBoardValueOf()
    return NumberFormat(number, _ValueOF === 2?'total':'standard', _ValueOF === 2?'default':'auto', 0)
    return NumberFormat(number, 'standard', 'auto', 0)
      if(number > 1000000){
          return `${(number/1000).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$& ')}K`
      }else if(number > 1000){
          return `${(number/1000).toFixed(0)}K`
      }else{
          return parseInt(number)
      }
  }

  handleGetVunnenMonthChartByUserid () {
    if(!isUndefined(this.props.currentAccount.id)) this.props.getVunnenMonthChartByUserid(this.props.authUser.user_id, this.props.currentAccount.id, [{Meta:"MonthYear",Value:this.props.LobbySetting.ForsaljningmotBudget}])
  }
  handleGetAktiviterByUserid () {
    if(!isUndefined(this.props.currentAccount.id)) this.props.getAktiviterByUserid(this.props.authUser.user_id, this.props.currentAccount.id, [])
  }
  handleGetMoteByUserid () {
    if(!isUndefined(this.props.currentAccount.id)) this.props.getMoteLobbyByUserid(this.props.authUser.user_id, this.props.currentAccount.id)
  }

  createAktivitetData () {
    if(isEmpty(this.props.AktiviterArr)){
      return [
      {label:<IntlMessages id="Activities.Type.option2"/>,value:0,percent:0},
      {label:<IntlMessages id="Activities.Type.option3"/>,value:0,percent:0},
      {label:<IntlMessages id="Activities.Type.option1"/>,value:0,percent:0},
      {label:<IntlMessages id="Activities.Type.option4"/>,value:0,percent:0},
    ]}
    else{
      let largetsAntal =  this.props.AktiviterArr.sort((a, b) => b.Antal - a.Antal)[0].Antal

      return this.props.AktiviterArr.sort((a, b) => b.Antal - a.Antal).map(AR => {
        return {label:AR.name,value:AR.Antal,percent:parseInt(AR.Antal)===0 ? 0 : (AR.Antal/largetsAntal) * 100}
      })
    }
  }
  componentDidMount() {
    // const userid = this.props.authUser.user_id
    //const Afid = this.props.authUser.user_Afid
    //this.props.getAfidLobbySittings(Afid)
    // this.props.getDashboardCompetitionList(userid,Afid)
  }

  render() {
    const { classes } = this.props;
    const { user_Afid, user_Email, user_Notification, user_SeeCasesList, user_SeeContractFlag, user_SeeDialer, 
      user_SeeEndClients, user_SeeOrderList, user_SeeRinglist, user_WeekNotification, user_fnamn, user_id, user_lnamn, user_role,SaljIntranat, user_CanSeeDashboardPlus }
      = this.props.authUser;
      console.log(SaljIntranat)
      console.log("JJJKKKK0",this.props.LobbySetting)
    return (
      <ReactGridLayout
        className="layout"
        useCSSTransforms={false}
        rowHeight={33}        
      >
        {/* <Paper style={{ background: 'rgb(12,150,156)', background: 'radial-gradient(circle, rgba(12,150,156,1) 25%, rgba(7,90,95,1) 100%)' }} key="1" data-grid={{ x: 0, y: 0, w: 12, h:2, static: false }} elevation={6}>
          <span><WelComeBanner WelcomedUser={user_fnamn + " " + user_lnamn} UserRole={user_role}> </WelComeBanner></span>
        </Paper> */}
        <Card style={{ backgroundColor: '#FFFFFF' }} key="1"
         data-grid={{ x: 0, y: 0, w: 3, h:isUndefined(this.props.Flags)?3:isNull(this.props.Flags.KontoLogo)?3:4, static: true }} 
         elevation={3}>
          <span className="text"><WelcomeCard WelcomedUser={user_fnamn + " " + user_lnamn} UserRole={user_role}> </WelcomeCard></span>
        </Card>
        {
          parseInt(SaljIntranat) === 1?
          <Card style={{ backgroundColor: '#FFFFFF' }} 
          key="4" 
          data-grid={{ x: 9, y: 0, w: 3, h: 3, static: true }} 
          elevation={3}>
            <span className="text">
              <Donut 
                mainTitle={this.props.intl.formatMessage({ id: 'Sales' })}
                subTitle={`${this.props.intl.formatMessage({ id: 'Outcome.Budget' })} ${parseInt(this.props.LobbySetting.ForsaljningmotBudget) === 1?this.props.intl.formatMessage({ id: 'month.lowerCase' }):this.props.intl.formatMessage({ id: 'Year.Short' })}`} 
                fvalue={this.formatNumber2(this.props.MonthVunnen)} 
                value={this.props.MonthVunnen} 
                increase="162%" 
                fofValue={isNull(this.props.UserBudget) ? 0 :this.formatNumber(this.props.UserBudget)} 
                ofValue={isNull(this.props.UserBudget) ? 0 : this.props.UserBudget} 
                intervalFunction={this.handleGetVunnenMonthChartByUserid}/>
              {/* <ExtraLargeProgress isFrom={1}/> */}
            </span>
          </Card>:<div key="4" data-grid={{ x: 9, y: 0, w: 3, h: 0, static: true }}></div>
        }
        {
          parseInt(SaljIntranat) === 1?
          <Card style={{ backgroundColor: '#FFFFFF' }} 
          key="6" 
          data-grid={{ x: 9, y: 3, w: 3, h: 3, static: true }} 
          elevation={3}>
            <span className="text">
              <Donut 
                mainTitle={this.props.intl.formatMessage({ id: 'Event.Booked' })}
                subTitle={`${this.props.intl.formatMessage({ id: 'Outcome.Budget' })} ${this.props.intl.formatMessage({ id: 'month.lowerCase' })}`} 
                increase="1%" 
                ofValue={isNull(this.props.UserMoteBudget) ? 0 : this.props.UserMoteBudget}
                value={this.props.BokadMote} 
                fofValue={isNull(this.props.UserMoteBudget) ? 0 : this.props.UserMoteBudget}
                fvalue={this.props.BokadMote} 
                intervalFunction={this.handleGetMoteByUserid}
                />
              {/* <ExtraLargeProgress isFrom={1}/> */}
            </span>
          </Card>:<div key="6" data-grid={{ x: 9, y: 3, w: 3, h: 0, static: true }}></div>
        }
          
        {
          parseInt(SaljIntranat) === 1?
          <Card style={{ backgroundColor: '#FFFFFF' }} 
          key="5" 
          data-grid={{ x: 9, y: 6, w: 3, h: 7, static: true }} 
          elevation={3}>
          <span className="text">
            {/* <Aktiviteter isFrom={1}/> */}
            <List data={this.createAktivitetData()} title={`${this.props.intl.formatMessage({ id: 'Title.Activitetis.Done' })} ` +moment().format('MMMM')}intervalFunction={this.handleGetAktiviterByUserid}/>
          </span>
        </Card>:<div key="5" data-grid={{ x: 9, y: 6, w: 3, h: 0, static: true }}></div>
        }

        {
          (parseInt(user_CanSeeDashboardPlus) === 1 && user_id !== 1)?
          <div key="7" 
            data-grid={{ x: 9, y: parseInt(SaljIntranat) === 1? 13 : 0, w: 3, h: 8, static: true }} >
            <DashboardTävlingar classes={classes}/>
          </div>
          :<div key="7" data-grid={{ x: 9, y: parseInt(SaljIntranat) === 1? 13 : 0, w: 3, h: 0, static: true }}></div>
        }
        <div 
        // style={{ backgroundColor: '#FFFFFF' }} 
        key="3" data-grid={{ x: 3, y: 0, w: 6, h: 15, static: true }}>
          <Flöde />
        </div>

        <div key="2" data-grid={{ x: 0, y: isUndefined(this.props.Flags)?3:isNull(this.props.Flags.KontoLogo)?3:4, w: 3, h: 15, static: true }} >
          <AttGöraNy />
          {/* <AttGöraTabell/> */}
        </div>
      </ReactGridLayout>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    getVunnenMonthChartByUserid: (userid,Afid,DashboardFilterOption) => dispatch(getVunnenMonthChartByUserid(userid,Afid,DashboardFilterOption)),
    getAktiviterByUserid: (userid,Afid,DashboardFilterOption) => dispatch(getAktiviterByUserid(userid,Afid,DashboardFilterOption)),
    getMoteLobbyByUserid: (userid,Afid) => dispatch(getMoteLobbyByUserid(userid,Afid)),
    getDashboardCompetitionList: (userid,Afid) => dispatch(getDashboardCompetitionList(userid,Afid)),
    
    dispatch
  }
}
function mapStateToProps({ accountsData, DashBoard}) {
  const {currentAccount, Flags,LobbySetting,DashBoardValueOf} = accountsData
  const {MonthVunnen, AktiviterArr, UserBudget, BokadMote, UserMoteBudget, DashboardCompetitionList} = DashBoard
  return {
    currentAccount, DashBoardValueOf,
    MonthVunnen, 
    AktiviterArr,
    UserBudget,
    BokadMote,
    UserMoteBudget,
    Flags,
    DashboardCompetitionList,
    LobbySetting
  }
}
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl 
)
(withStyles(styles, { withTheme: true })(StaticElementsLayout))